export const HUBSPOT_USER_TYPE_ID = 100;
export const HUBSPOT_ACTOR_TYPE = 'HUBSPOT';
export const USER_ACTOR_TYPE = 'USER';
export const INTEGRATION_ACTOR_TYPE = 'INTEGRATION';
export const ALL_USERS = 'ALL';
export const ALL_OBJECT_TYPES = 'ALL_OBJECT_TYPES';